import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Kooperationspartner() {
	return (
		<div>
			<HelmetProvider>
				<Helmet>
					<title>Kooperationspartner</title>
					<meta name="description" content="Kooperationspartner" />
					<meta
						name="keywords"
						content="Kooperationspartner , justech , Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="alt-font">
				<h2 id="kooperationspartner">Kooperationspartner </h2>
				<p>
					<img src="https://feingeist-beratung.de/wp-content/uploads/2023/12/justech.png" />
				</p>
			</div>
		</div>
	);
}
